var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
    [
      _vm.showModalDespacho
        ? _c("app-modal-selecionar-modelo-notificacao", {
            attrs: {
              tiposModelo: _vm.tiposModelo,
              titulo: "Modelos de Despacho",
              showModal: _vm.showModalDespacho
            },
            on: {
              closeModal: _vm.fecharModalDespacho,
              setTextoDespacho: _vm.setTextoDespacho
            }
          })
        : _vm._e(),
      _vm.processo
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-col",
                { staticClass: "center", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do Interessado:",
                      content: _vm.processo.nomeRazaoSocialInteressado
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Número do processo:",
                      content: _vm.processo.numeroProcesso
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "CPF do Interessado:",
                      content: _vm.processo.cpfCnpjInteressado
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Tipo de Processo:",
                      content: _vm.processo.tipo.nome
                    }
                  })
                ],
                1
              ),
              _c("app-opcoes-header-analise", {
                staticClass: "right",
                attrs: {
                  idProcesso: _vm.processo.id,
                  numeroProcesso: _vm.processo.numeroProcesso,
                  tipoProcesso: _vm.processo.tipo.codigo,
                  protocolo: _vm.processo.numeroProtocolo,
                  idDespacho: _vm.idDespacho
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.dadosCadastros
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "div",
                                { staticClass: "flex-despacho" },
                                [
                                  _c("p", { staticClass: "label" }, [
                                    _vm._v("Despacho"),
                                    _c("span", { staticClass: "required" }, [
                                      _vm._v("  *  ")
                                    ])
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.openModalDespacho }
                                    },
                                    [
                                      _vm._v("Modelo  "),
                                      _c("div", { staticClass: "fa fa-file" })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("app-editor-texto", {
                                ref: "editorTexto",
                                staticClass: "input",
                                class: { erro: errors.length },
                                on: { onTextChange: _vm.onTextChange },
                                model: {
                                  value: _vm.textoDespacho,
                                  callback: function($$v) {
                                    _vm.textoDespacho = $$v
                                  },
                                  expression: "textoDespacho"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      30055700
                    )
                  }),
                  _c("app-anexo", {
                    attrs: {
                      id: "upload-anexo-despacho",
                      files: _vm.anexos,
                      tipoExibir: "ANEXO_ANALISE"
                    },
                    on: {
                      uploadFile: _vm.uploadFile,
                      removeFile: _vm.removeFile,
                      downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
                    }
                  }),
                  _vm.showButtonsTramitacao
                    ? _c("app-radios-tramitacao", {
                        attrs: {
                          radios: _vm.acoesRadio,
                          isDecisao: _vm.isDecisao
                        },
                        on: { changeRadio: _vm.changeRadio }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("app-buttons-cadastro", {
        attrs: {
          isUltimoPasso: true,
          isPrimeiroPasso: true,
          showButtonSalvar: false
        },
        on: { finalizar: _vm.finalizar, cancelar: _vm.cancelar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310f5ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310f5ce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ordemServico/SolicitarArquivamento.vue
// module id = null
// module chunks = 